export const DOCS_LINKS = {
	aiAgent: 'https://binary.so/docs/ai-agent/what-the-agent-can-do',
	assignments: 'https://binary.so/docs/assignments/create-an-assignment',
	careersPage: 'https://binary.so/docs/getting-started/careers-page',
	chromeExtension: 'https://binary.so/docs/settings/integrations/chrome-extension',
	emailCandidates: 'https://binary.so/docs/messaging/message-candidates',
	interviewFeedback: 'https://binary.so/docs/interviews/interview-feedback',
	interviewScheduling: 'https://binary.so/docs/interviews/schedule-interviews',
	jobAnalytics: 'https://binary.so/docs/analytics/job-analytics',
	linkedinJobFeed: 'https://binary.so/docs/settings/integrations/linkedin-job-feed',
	mcp: 'https://binary.so/docs/settings/integrations/mcp',
	membersAndRoles: 'https://binary.so/docs/getting-started/members-and-roles',
	offerLetters: 'https://binary.so/docs/offers/send-an-offer-letter',
	referrals: 'https://binary.so/docs/referrals/refer-candidates',
	slack: 'https://binary.so/docs/settings/integrations/slack',
	usageAndCredits: 'https://binary.so/docs/getting-started/usage-and-credits',
	workspaceAnalytics: 'https://binary.so/docs/analytics/workspace-analytics',
} as const;
